import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AttachmentsModule } from '../attachments/attachments.module';
import { DialogModule } from '../dialog/dialog.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { FeedbackCardComponent } from './components/feedback-card/feedback-card.component';
import { FeedbackDialogComponent } from './components/feedback-dialog/feedback-dialog.component';
import { TrackingModule } from '../tracking/tracking.module';

const components = [FeedbackCardComponent, FeedbackDialogComponent];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    AttachmentsModule,
    FormMasterModule,
    TrackingModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class FeedbackModule {}
